class operators {
  constructor(operId, login, nombre, level, from, to) {
    this.operId = operId;
    this.nombre = nombre;
    this.login = login;
    this.level = level;
    this.from = from;
    this.to = to;
  }
  static fromJson({
    operId,
    login,
    nombre,
    nivel,
    fecAlta,
    fecBaja,
    pass,
    dbGrupo,
    ws,
    orden,
    roleId,
    cultureId,
    correoE,
    passAct,
    connectAs,
    connectPass,
    connectPassAct,
  }) {
    return new operators(
      operId,
      login,
      nombre,
      nivel,
      fecAlta,
      fecBaja,
      pass,
      dbGrupo,
      ws,
      orden,
      roleId,
      cultureId,
      correoE,
      passAct,
      connectAs,
      connectPass,
      connectPassAct
    );
  }
}
export default operators;
